import { defineMessages } from 'react-intl';

export default defineMessages({
  errorBannerOffline: { defaultMessage: 'You need to be connected to the Internet to use MyMedicoach.' },
  genericPageTitle: { defaultMessage: 'Welcome' },
});
